<template>
  <li
    class="v-middleBannerWrap"
  >
    <div v-if="middleBanner.free_field" v-html="middleBanner.free_field"
      :class="middleBanner.free_field_wrap_class ? middleBanner.free_field_wrap_class : ''"
      :style="middleBanner.free_field_wrap_style ? middleBanner.free_field_wrap_style : ''"
    >
    </div>
    <div v-else
       class="v-middleBanner"
      :style="`background-image: linear-gradient(to bottom, rgba(0, 0, 0, .3), rgba(0, 0, 0, .3)), url(${ middleBanner.background });`"
    >
      <a class="v-middleBanner__inner" data-ga-event-name="internal_link" data-ga-event-area="middle_banner" :href="middleBanner.link_url" v-if="middleBanner.link_url">
        <div class="v-middleBannerHeading" v-if="middleBanner.heading_main || middleBanner.heading_sub">
          <div class="v-middleBannerHeading__main" v-if="middleBanner.heading_main" v-html="middleBanner.heading_main"></div>
          <div class="v-middleBannerHeading__sub" v-if="middleBanner.heading_sub" v-html="middleBanner.heading_sub"></div>
        </div>
        
        <div class="v-middleBanner__text" v-if="middleBanner.text" v-html="middleBanner.text"></div>
        <div class="v-middleBanner__buttonWrap" v-if="middleBanner.link_text">
          <span class="v-middleBanner__button">
            {{ middleBanner.link_text }}
          </span>
        </div>
      </a>

      <div class="v-middleBanner__inner" v-else>
        <div v-if="middleBanner.text">{{ middleBanner.text }}</div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    middleBanner: {
      type: Object,
      required: true,
    },
  },

  name: 'MiddleBanner',
}
</script>

<style lang="scss" scoped>
  .v-middleBannerWrap {
    grid-column: span 2;
  }
  .v-middleBanner {
    background-size: cover;
    background-position: bottom;
    height: 100%;
    min-height: 227px;

    &__inner {
      display: flex;
      flex-direction: column;
      height: 100%;
      text-decoration: none;
      color: #fff;
      padding: 20px;

      @media screen and (min-width: 900px) {
        padding-top: 30px;
      }
    }

    &__text {
      font-size: 10px;
      margin-bottom: 10px;
      line-height: 2.2;
      @media screen and (min-width: 900px) {
        font-size: 14px;
        margin-bottom: 20px;
      }
    }

    &__buttonWrap {
      margin-top: auto;
    }

    &__button {
      display: inline-block;
      padding: 10px 25px;
      border: 1px solid;
      border-radius: 3px;
      font-size: 10px;
      line-height: 1;
      
      @media screen and (min-width: 900px) {
        padding: 13px 25px;
        font-size: 12px;
        min-width: 235px;
        text-align: center;
      }
    }
  }

  .v-middleBannerHeading {
    margin-bottom: 10px;
    line-height: 1;
    @media screen and (min-width: 900px) {
      margin-bottom: 30px;
    }

    &__main {
      font-size: 18px;
      font-family: var(--sans-serif-en);
      margin-bottom: 7px;
      @media screen and (min-width: 900px) {
        font-size: 28px;
        margin-bottom: 10px;
      }
    }

    &__sub {
      font-size: 14px;
      line-height: 1.4;
      @media screen and (min-width: 900px) {
        font-size: 15px;
      }
    }
  }
</style>
